import styled from "styled-components";

export const DropdownWrapper = styled.div`
  //.ui.selection.dropdown .menu > .item {}
`;
